const actionTypes = {
	ADD: 'notifications/ADD',
	REMOVE: 'notifications/REMOVE'
}
export default actionTypes
